module.exports = new __parcel__URL__("puissancebrick.34b746ad.png").toString();